import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetConfigurationVersionAndSectionsResData } from "./GetConfigurationVersionAndSectionsResData";

const ENDPOINT = "/caosconfiguration/version";

export class GetConfigurationVersionAndSectionsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetConfigurationVersionAndSectionsReqData = null;

    constructor(params) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetConfigurationVersionAndSectionsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetConfigurationVersionAndSectionsResData(res);
    }
}

export class GetConfigurationVersionAndSectionsReqData {
    installationName: string;

    constructor(installationName: string) {
        this.installationName = installationName;
    }
}
